import type {InjectionKey, Ref} from "vue";

export const blogPageSchemaNameKey: InjectionKey<Ref<string>> = Symbol.for(
  "app:blog-page-schema",
);
